import { styled, Text } from '@chilipiper/design-system'
import { stylesChatLinks } from '../styles'

export const ThemedText = styled(Text)`
  word-break: break-word;

  p {
    padding: 0;
    margin: 0;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    letter-spacing: inherit;
  }

  ${stylesChatLinks}
`
